var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.8913C0 15.3536 0.17779 15.797 0.494257 16.1239C0.810725 16.4508 1.23995 16.6345 1.6875 16.6345H16.3125C16.7601 16.6345 17.1893 16.4508 17.5057 16.1239C17.8222 15.797 18 15.3536 18 14.8913V6.75672C18 6.29441 17.8222 5.85104 17.5057 5.52414C17.1893 5.19724 16.7601 5.01359 16.3125 5.01359H1.6875C1.23995 5.01359 0.810725 5.19724 0.494257 5.52414C0.17779 5.85104 0 6.29441 0 6.75672L0 14.8913ZM2.25 3.27045C2.25 3.42456 2.30926 3.57235 2.41475 3.68131C2.52024 3.79028 2.66332 3.8515 2.8125 3.8515H15.1875C15.3367 3.8515 15.4798 3.79028 15.5852 3.68131C15.6907 3.57235 15.75 3.42456 15.75 3.27045C15.75 3.11635 15.6907 2.96856 15.5852 2.85959C15.4798 2.75063 15.3367 2.68941 15.1875 2.68941H2.8125C2.66332 2.68941 2.52024 2.75063 2.41475 2.85959C2.30926 2.96856 2.25 3.11635 2.25 3.27045ZM4.5 0.946278C4.5 1.10038 4.55926 1.24817 4.66475 1.35714C4.77024 1.46611 4.91332 1.52732 5.0625 1.52732H12.9375C13.0867 1.52732 13.2298 1.46611 13.3352 1.35714C13.4407 1.24817 13.5 1.10038 13.5 0.946278C13.5 0.792176 13.4407 0.644385 13.3352 0.535418C13.2298 0.426451 13.0867 0.365234 12.9375 0.365234H5.0625C4.91332 0.365234 4.77024 0.426451 4.66475 0.535418C4.55926 0.644385 4.5 0.792176 4.5 0.946278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLib);
export default __webpack_public_path__ + "static/media/lib.281b25e847b2b30b3c41f78e4c582cc2.svg";
export { ForwardRef as ReactComponent };